import { render, staticRenderFns } from "./WaitToDownload.vue?vue&type=template&id=2bfe81eb&scoped=true&"
import script from "./WaitToDownload.vue?vue&type=script&lang=js&"
export * from "./WaitToDownload.vue?vue&type=script&lang=js&"
import style0 from "./WaitToDownload.vue?vue&type=style&index=0&id=2bfe81eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfe81eb",
  null
  
)

export default component.exports